import Image from "next/image";
import Link from "next/link";
import React from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import slugify from "slugify";

export default function BlogCard({ category, slug, tags, coverImage, title, authorName, publishedOn }) {
  return (
    <div>
      <Link
        href={`/blog/${slugify(category, { lower: true, strict: true })}/${slug}`}
        className="group relative flex h-[348px] w-[310px] flex-col gap-5 rounded-md bg-white p-3 shadow-lg hover:shadow-xl dark:border dark:border-primary/30 dark:bg-transparent"
      >
        <div className="absolute right-5 top-5 hidden rounded-md border-[3px] border-primary bg-primary px-2 py-1 text-sm font-semibold text-white group-hover:block">
          {tags[0]}
        </div>
        <div className="h-[65%] ">
          <Image
            className="h-full w-full rounded-md object-cover hover:cursor-pointer "
            src={coverImage}
            alt="loaded soon"
            loading="eager"
            width={300}
            height={200}
          />
        </div>
        <div className="flex h-[35%] flex-col justify-between gap-3 hover:cursor-pointer ">
          <div className="line-clamp-2 h-1/2 overflow-hidden font-medium">
            {title}
          </div>
          <div className="flex h-1/2 items-center justify-between text-sm text-body-color dark:text-body-color-dark ">
            <span>By {authorName}</span>
            <span className="flex items-center justify-center gap-1">
              <FaRegCalendarAlt />
              {publishedOn.split("on")[1] || publishedOn}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
}
